import { useEffect, useState } from "react";
import { useSearchParams, Navigate, Link } from "react-router";
import { verifyMagicLink } from "../../api/auth.api";
import { useAuthStore } from "../../stores/auth.store";
import { getSession } from "../../api/auth.api";

export function MagicLinkCallback() {
  const [searchParams] = useSearchParams();
  const token = searchParams.get("token");
  const [status, setStatus] = useState<"loading" | "success" | "error">("loading");
  const [isNew, setIsNew] = useState(false);
  const setUser = useAuthStore((s) => s.setUser);

  useEffect(() => {
    if (!token) {
      setStatus("error");
      return;
    }

    let cancelled = false;
    async function verify() {
      try {
        const result = await verifyMagicLink(token!);
        const { user } = await getSession();
        if (!cancelled) {
          setUser(user);
          setIsNew(result.isNew ?? false);
          setStatus("success");
        }
      } catch {
        if (!cancelled) setStatus("error");
      }
    }
    verify();
    return () => { cancelled = true; };
  }, [token, setUser]);

  if (status === "loading") {
    return (
      <div className="flex flex-col items-center gap-4 py-16">
        <div className="h-8 w-8 animate-spin rounded-full border-4 border-gray-200 border-t-gray-900" />
        <p className="text-gray-600">Verifying your login link...</p>
      </div>
    );
  }

  if (status === "success") {
    return <Navigate to={isNew ? "/register" : "/"} replace />;
  }

  return (
    <div className="flex flex-col items-center gap-4 py-16 text-center">
      <h1 className="text-2xl font-bold">Link expired or invalid</h1>
      <p className="text-gray-600">This login link is no longer valid. Please request a new one.</p>
      <Link
        to="/login"
        className="rounded-lg bg-gray-900 px-6 py-3 font-medium text-white hover:bg-gray-800"
      >
        Back to login
      </Link>
    </div>
  );
}
